import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Bank } from '@/types';
    import ContinueButton from '@/components/ContinueButton.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import ConnectEconomicForm from '@/components/bank/ConnectEconomicForm.vue';
    import { useForm } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectEconomic',
  props: {
    bank: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        account_id: props.bank.id,
        contra_account_id: props.bank.db_account?.contra_account_nr ?? null,
    });

    const successMessage = computed(() => {
        return form.contra_account_id
            ? 'viia.connect_economic_success'
            : 'viia.connect_economic_success_no_contra_account';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.bank.attach-account'),
    "query-key": [_unref(QueryKey).BANK, selectedCompanyId.value],
    title: "viia.connect_economic",
    "success-message": successMessage.value,
    "error-message": "viia.connect_economic_error",
    "submit-text": "viia.connect_economic"
  }, {
    trigger: _withCtx(() => [
      _createVNode(ContinueButton, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('viia.connect_economic')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(ConnectEconomicForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "success-message"]))
}
}

})